import { Guid } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseProductQuantityHistoryRestockResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;
}
